import theme from './theme'
import styled from 'styled-components'

export const Tour = styled.main`
  max-width: 400px;
  margin: 4rem auto;
  padding: 0 ${theme.paddingAround};
  min-height: 60vh;
`
